import {
  Component
} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ModalController
} from 'ionic-angular';
import {
  FacilityProvider
} from '../../providers/facility/facility';
import {
  ToastProvider
} from '../../providers/toast/toast';
import {
  FacilityPage
} from '../facility/facility';
import {
  UtilService
} from '../../services/util';
import {
  TranslateService
} from '@ngx-translate/core';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  TermsAndConditionPage
} from '../terms-and-condition/terms-and-condition';
import {
  MakePaymentPage
} from '../make-payment/make-payment';
import moment from 'moment';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';
import { LoginProvider } from '../../providers/login/login';

@IonicPage()
@Component({
  selector: 'page-booking',
  templateUrl: 'booking.html',
})
export class BookingPage {
  location: any;
  fromDate: string;
  today: Date;
  toDate: string;
  fromTime: string;
  toTime: string;
  disabled = true;
  bookings: any;
  slotDay: any
  maxDate: Date
  minDate:Date;
  alreadyBookSlot: any
  terms: boolean = false
  days = [this.translate.instant('DAY_SUN'), this.translate.instant('DAY_MON'), this.translate.instant('DAY_TUE'), this.translate.instant('DAY_WED'), this.translate.instant('DAY_THU'), this.translate.instant('DAY_FRI'), this.translate.instant('DAY_SAT')];
  page: string;
  _show_no_availability_days: boolean;
  clickSlot: any;
  selRegistrationLogin: any;
  outstandings = [];
  status:string;
  allowedTimings='';
  permissions:any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private facilityProvider: FacilityProvider,
    private toast: ToastProvider,
    private loadingCtrl: LoadingController,
    private viewCtrl: ViewController,
    private util: UtilService,
    private alertCtrl: AlertController,
    private login: LoginProvider,
  ) {
    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
    this.location = this.navParams.get("location");
    if(this.location){
      this.getForm();
      this.page = 'details';
      this.setDefaultDates()
      this.makeData();
      this.status = this.getBookingStatus(this.location)
    }
  }
  getBookingStatus(location){
   let x = this.facilityProvider.getBookingStatus(location)
   if(x=='Closed'){
    this.allowedTimings = this.facilityProvider.getBookingTime(location)
   }
   return x
  }
  setDefaultDates() {
    this.today = this.location.valueData.date ? new Date(this.location.valueData.date) : new Date()
    var futureDays = this.location.rules ? this.location.rules.no_of_future_days : 0
    this.maxDate = futureDays?moment().add(futureDays,'day').toDate() : moment().toDate()
    //
    if(this.location.rules && this.location.rules.default_date){
      let d = moment().add(this.location.rules.default_date, 'day').toDate();
      this.today = d
      this.setToDate(d)
      this.setFromDate(d)
    }else{
      this.setToDate(new Date())
      this.setFromDate(new Date())
    }
  }

  makeData() {
    if (this.location.slot) {
      this.days.forEach((x, index) => {
        if (this.location.slot[(index)]) {
          if (this.location.slot[(index)].avl == true) {
            this.location.slot[(index)].hrs.forEach((time, indexNo) => {
              var fromTime = (time.from).split(':');
              var toTime = (time.to).split(':');
              var ft = moment(new Date(0, 0, 0, fromTime[0], fromTime[1])).format('h:mm a');
              var tt = moment(new Date(0, 0, 0, toTime[0], toTime[1])).format('hh:mm a');
              time.fromTo =  ft+' - '+tt
            });
          }
        }
      });
    }
    this._show_no_availability_days = false;
    if (this.location.no_availability_days) {
      this.location.no_availability_days.forEach(obj => {
        if (obj.d > this.today.toISOString()) {
          this._show_no_availability_days = true;
        }
        // console.log(obj.d+ " > " +this.today.toISOString() +" ===> "+(obj.d > this.today.toISOString()));
      });
    }
  }

  checkValidation(valueData) {
    if (this.location.formData) {
      if (valueData) {
        var d = true
        this.location.formData.forEach(val => {
          if ((val.rule == 'required' && valueData[val.col_name] == undefined) || (!valueData[val.col_name] && valueData[val.col_name] == '' && val.rule == 'required')) {
            d = false
            this.toast.presentToast(`Please Enter the ${val.name}`);
          }
        })
        d = d ? true : d
      }
    } else {
      d = true
    }
    return d
  }

  makePayment(amount, billTypeObject) {
    this.selRegistrationLogin = localStorage.getItem('signup_login');

    if (this.selRegistrationLogin) {
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    } else {
      this.navCtrl.push(MakePaymentPage, {
        amount,
        billType: billTypeObject,
        outstanding: this.outstandings
      });
    }
  }

  onEvent() {
    let from = this.fromDate + " " + this.fromTime;
    let to = this.toDate + " " + this.toTime;
    let loader = this.loadingCtrl.create({});
    loader.present().then(() => {
      if (this.checkValidation(this.location.valueData)) {
        var data = this.location.valueData ? this.location.valueData : {}
        if (this.location.valueData && this.location.valueData.openModal) {

          var d = {
            locationId: this.location.id,
            from: from,
            to: to,
            data: data
          }
          this.dismissModal(d)
          loader.dismiss();
        } else {
          const BOOKED_STATUS = 1;
          this.facilityProvider.bookSlot(this.location.id, from, to, data, this.location.valueData.pass_id, BOOKED_STATUS).then(val => {
            loader.dismiss();
            if (val.status == "success") {
              this.toast.presentToast(val.message);
              this.navCtrl.push(FacilityPage, {
                type: this.location.type
              }).then(() => {
                this.util.clearNavStack(this.navCtrl);
              });
            } else {
              this.toast.presentToast(val.message);
            }
          });
        }
      } else {
        loader.dismiss();
        this.toast.presentToast(`Please Enter All Details`);
      }
    });
  }
  setFromDate($event) {
    var d = false
    this.fromDate = this.getDateFormat($event);
    this.findBookings()
    if (this.location.no_availability_days) {
      this.location.no_availability_days.forEach(val => {
        if (val.d == this.fromDate) {
          d = true
          this.toast.presentToast(`Booking Not Allow \n Remarks: ${val.r}  `);
        }
      })
    }

    if (!d) {
      if (this.location.rules && this.location.rules.pre_defined_slot_only) {
        this.slotDay = new Date(this.fromDate).getDay();
        this.checkAlreadyBooking();
      }
    } else {
      this.slotDay = ""
    }
    // this.fromDate = this.datePipe.transform($event,'yyyy-dd-mm')
  }
  setToDate($event) {
    this.toDate = this.getDateFormat($event);
  }
  getDateFormat(dateData) {
    if (dateData) {
      let d = dateData,
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    }
    return dateData;
  }
  checkSlot() {
    if (this.fromDate && this.toDate && this.fromTime && this.toTime) {
      let from = this.fromDate + " " + this.fromTime;
      let to = this.toDate + " " + this.toTime;
      this.facilityProvider.checkSlot(this.location.id, from, to).then(val => {
        if (val.status == "success" && val.data && val.data.length == 0) {
          this.disabled = false;
        } else {
          if (this.location.type == 'PARKING') {
            if (val.data.length == this.location.rules.max_booking_allowed) {
              this.disabled = true;
              this.toast.presentToast(`Booking Not Allow For ${this.formatDate(this.fromDate)} from ${this.formatTime(this.fromTime)} - ${this.formatTime(this.toTime)}`);
            } else {
              this.disabled = false;
            }
          } else {
            this.disabled = true;
            let str = this.fromDate == this.toDate ? ' ' : ` ${this.formatDate(this.toDate)}`
            this.toast.presentToast(`Booking Not Allow For ${this.formatDate(this.fromDate)} from ${this.formatTime(this.fromTime)} -${str} ${this.formatTime(this.toTime)}`);
          }
        }
      });
    }
  }
  formatDate(date) {
    return moment(date).format('D MMM')
  }
  formatTime(time) {
    console.log(time, '-------')
    let t = '2000-01-01 ' + time + ':00'
    return moment(t).format('hh:mm a')
  }

  checkAlreadyBooking() {
    var ft
    var tt

    this.facilityProvider.checkSlotBooked(this.location.id, this.fromDate).then(val => {
      if (val.status == "success") {
        this.alreadyBookSlot = val.data
        var parkCount = {}
        if (this.location.slot && this.location.slot[this.slotDay]) {
          this.alreadyBookSlot.forEach((val) => {
            ft = new Date(val.booking_from)
            tt = new Date(val.booking_to)
            val.fromTo = (ft.getHours() > 12 ? ((ft.getHours()) - 12) : ft.getHours()) + "" + ((ft.getMinutes() > 0) ? ':' + ((ft.getMinutes() > 10) ? ft.getMinutes() : '0' + ft.getMinutes()) : '') + "" + ((ft.getHours() > 11) ? 'pm' : 'am') +
              " - " + (tt.getHours() > 12 ? ((tt.getHours()) - 12) : tt.getHours()) + "" + ((tt.getMinutes() > 0) ? ':' + ((tt.getMinutes() > 10) ? tt.getMinutes() : '0' + tt.getMinutes()) : '') + "" + ((tt.getHours() > 11) ? 'pm' : 'am');
            this.location.slot[this.slotDay].hrs.forEach((slot) => {
              parkCount[`${val.fromTo}`]
              if ((slot.fromTo == val.fromTo) && (this.getDateFormat(ft) == this.fromDate)) {
                parkCount[val.fromTo] = (parkCount[val.fromTo] ? parkCount[val.fromTo] : 0) + 1
                if (this.location.type && this.location.type == 'PARKING' && parkCount[val.fromTo] >= this.location.rules.max_booking_allowed) {
                  slot.isAvailable = false
                } else if (!this.location.type || this.location.type != 'PARKING') {
                  slot.isAvailable = false
                }

              }
            })
          })
        }
      }
    });
  }

  isPreDefinedSlotCheck(fromDate, toDate, fromTime, toTime, currentSlot: string) {
    this.clickSlot = currentSlot
    this.fromDate = fromDate
    this.toDate = toDate
    this.fromTime = fromTime
    this.toTime = toTime
    this.checkSlot();
  }

  doPrepaidPayment(fromDate, toDate, fromTime, toTime, currentSlot: string, amount, billType) {
    this.isPreDefinedSlotCheck(fromDate, toDate, fromTime, toTime, currentSlot);
    this.outstandings = ['id', [billType],
      'data', ['balance', [amount], ]
    ];

    let from = this.fromDate + " " + this.fromTime;
    let to = this.toDate + " " + this.toTime;
    const PREPAID_BOOKING = 3;
    this.facilityProvider.bookSlot(this.location.id, from, to, null, this.location.valueData.pass_id, PREPAID_BOOKING).
    then(val => {
      if (val.status == "success") {
        var billTypeObject = {
          'id': billType,
          'amenity': {
            'booking_id': val.data.id,
            'name': this.location.name,
            'slot': currentSlot,
            'from': fromTime,
            'to': toTime,
            'fromDate': fromDate,
          }
        }
        this.makePayment(amount, billTypeObject);
      } else {
        this.toast.presentToast(val.message);
      }
    });

  }

  findBookings() {
    this.bookings = null;
    this.facilityProvider.findBookings(this.location.id, this.fromDate).then(val => {
      if (val.status == "success") {
        this.bookings = val.data;
      }
    });
  }

  getForm() {
    if (this.location.type == 'PARKING') {
      var data = {
        'form_type': 'PARKING_FORM',
        'default': '1'
      }
      // this.location.formData = [
      //   {$$hashKey: "5E74",id:12,name:'Name',col_name:'name',type:'Text',default_value:null,society_id:null,created_at:null,updated_at:null,rule:'required',order:null,option:null,data:null,is_system:0,is_enable:1},
      //   {$$hashKey: "5E83",id:13,name:'Phone No',col_name:'phone_no',type:'Number',default_value:null,society_id:null,created_at:null,updated_at:null,rule:'required',order:null,option:null,data:null,is_system:0,is_enable:1},
      //   {$$hashKey: "5E99",id:14,name:'Vehicle No',col_name:'vehicle_no',type:'Text',default_value:null,society_id:null,created_at:null,updated_at:null,rule:'required',order:null,option:null,data:null,is_system:0,is_enable:1},

      // ] 
      this.facilityProvider.getForm(data).then(val => {
        if (val.data && val.status == 'success') {
          this.location.formData = val.data
        }
      })
    }
  }

  dismissModal(data) {
    data = data ? data : ''
    this.viewCtrl.dismiss(data);
  }
  isBookingValid() {
    if(this.status!='Open'){
      return false
    }
    let dt = this.fromDate && this.fromTime && this.toDate && this.toTime
    if (!this.location.rules || !this.location.rules.tc) {
      return dt
    } else {
      let rules = this.location.rules && this.location.rules.tc && this.terms
      return dt && rules
    }
  }
  openTerms(event, data) {
    let modal = this.modalCtrl.create(TermsAndConditionPage, {
      data
    });
    modal.present();
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad BookingPage');
  
  }
  checkBookPermission(mod,type){
  
    let perPipe = new PermissionCheckPipe();
if (perPipe.transform(this.permissions, mod, type)) {
return true
}
else{
  return false
}
   }

}


// WEBPACK FOOTER //
// ./src/pages/booking/booking.ts